import { useEffect, useRef } from 'react';
import { analytics } from '@/services/analytics';

/** Debounce de buscas ≥2 chars para não floodar o ingest. */
export function useTrackSearch(query: string, resultCount: number, enabled = true) {
  const lastSent = useRef('');

  useEffect(() => {
    if (!enabled) return;
    const q = query.trim();
    if (q.length < 2) return;

    const timer = window.setTimeout(() => {
      const key = `${q}|${resultCount}`;
      if (key === lastSent.current) return;
      lastSent.current = key;
      void analytics.search({ query: q, resultCount });
    }, 700);

    return () => window.clearTimeout(timer);
  }, [query, resultCount, enabled]);
}
